import React from 'react';
import SectionWithLeftIcon from 'components/organisms/section/sectionWithLeftIcon';
import certificateIcon from 'assets/icons/certifications/certificate.svg';
import Badge from 'components/atoms/badge';
import Heading from 'components/atoms/text/heading';
import locationIcon from 'assets/icons/education/location.svg';
import dateIcon from 'assets/icons/education/date.svg';
import istqbCertificate from 'assets/images/certifications/istqb-certificate.jpg';

export default function Certifications() {
  return (
    <div className="flex flex-col gap-4">
      <SectionWithLeftIcon
        title={
          <Heading
            wrapText
            styles="w-full text-center md:text-start"
            text="Foundation Certificate in Software Testing"
          />
        }
        icon={certificateIcon}
        alt="Bachelor's degree"
        iconFooter="Certification"
        iconLink={istqbCertificate}>
        <div className="w-full pt-3">
          <div className="flex justify-center md:justify-start flex-wrap gap-x-4 gap-y-2">
            <Badge text="ISTQB" iconSrc={locationIcon} iconAlt="Graduation location" addIconPadding />
            <Badge text="July 2019" iconSrc={dateIcon} iconAlt="Graduation date" />
          </div>
        </div>
      </SectionWithLeftIcon>
    </div>
  );
}
